import React, { useState } from 'react'
import { Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RequiredLabel } from '../utils/validators';
import { createConcepts } from '../services/Concepts';

function AddConcept() {
  const [isLoading, setIsLoading] = useState(false);
  const [description, setDescription] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const navigate = useNavigate();

  const redirectBack = () => navigate(`/concepts`);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!description.trim()) return toast.warn('El nombre es requerido');

    try {
      setIsSaving(true);
      await createConcepts({ description });
      toast.success('Concepto creado');
      navigate('/concepts');
    } catch (err) {
      console.error(err);
      toast.warn('Ese concepto ya existe');
      toast.error('No se pudo crear el concepto');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      {isLoading ? (
        <Spinner animation="border" role="status" />
      ) : (
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formConceptName" className="mb-3">
            <Form.Label as={RequiredLabel} required>Nombre:</Form.Label>
            <Form.Control
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Ej. Cobertura"
              maxLength={350}
            />
          </Form.Group>

          <Row>
            <Col xl={12} className='text-center'>
              <Button className='m-3' variant="secondary" type="button" onClick={redirectBack} disabled={isSaving}>
                Cancelar o regresar
              </Button>
              <Button className='m-3' variant="primary" type="submit" disabled={isSaving}>
                {isSaving ? 'Guardando...' : 'Crear concepto'}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
      <ToastContainer />
    </div>
  );
}

export default AddConcept;